import { render, staticRenderFns } from "./epb-bulk-action-checkbox.component.vue?vue&type=template&id=5f2e2700&scoped=true"
import script from "./epb-bulk-action-checkbox.component.vue?vue&type=script&lang=ts"
export * from "./epb-bulk-action-checkbox.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-bulk-action-checkbox.component.vue?vue&type=style&index=0&id=5f2e2700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e2700",
  null
  
)

export default component.exports